/* eslint-disable @typescript-eslint/camelcase */
import t from '@jetshop/intl';
export const translations = {
    country: t('Select country'),
    country_placeholder: t('Select country'),
    city: t('City'),
    city_placeholder: t('City'),
    co: t('Extra address'),
    co_placeholder: t('Extra address'),
    companyAtt: t('Company contact name'),
    companyAtt_placeholder: t('Company contact name'),
    company: t('Company'),
    companyName: t('Company'),
    companyName_placeholder: t('Company'),
    department: t('Department'),
    department_placeholder: t('Department'),
    email: t('E-mail address'),
    email_placeholder: t('E-mail address'),
    firstName: t('First name'),
    firstName_placeholder: t('First name'),
    lastName: t('Surname'),
    lastName_placeholder: t('Surname'),
    mobilePhone: t('Mobile phone number'),
    mobilePhone_placeholder: t('Mobile phone number'),
    municipality: t('County'),
    municipality_placeholder: t('County'),
    phone: t('Telephone number'),
    phone_placeholder: t('Telephone number'),
    organizationNumber: t('Company registration number'),
    organizationNumber_placeholder: t('Company registration number'),
    pid: t('National ID/Social Security number'),
    company_pid: t('Company registration number'),
    postalCode: t('Post code'),
    postalCode_placeholder: t('Post code'),
    region: t('Region'),
    region_placeholder: t('Region'),
    streetName: t('Address'),
    streetName_placeholder: t('Address'),
    password: t('Desired password'),
    password_placeholder: t('Desired password'),
    confirmPassword: t('Repeat desired password'),
    confirmPassword_placeholder: t('Repeat desired password')
};
//# sourceMappingURL=signup-field-translations.js.map